'use strict';

var app = {

  settings: {
    duration: 400,
    easing: 'easeOutQuart',
    easeInOut: 'easeInOutQuart'
  },

  vars: {
    browser: undefined,
    browserVersion: undefined,
    os: undefined,
    touch: false
  },

  states: {
    isActive: 'is-active',
    isOpen: 'is-open',
    isDisabled: 'is-disabled',
    isHidden: 'is-hidden'
  },

  init: function init() {
    this.getJsData();
    this.initGlobalExtensions();
    this.initLocalExtensions($('body'));
    $('html').addClass('is-page-loaded');
  },

  parse: function parse($context) {
    this.initLocalExtensions($context);
  },

  initGlobalExtensions: function initGlobalExtensions() {
    var t = this;
    for (var globalExt in t.globalExt) {
      if (!app.obj[globalExt]) {
        app.obj[globalExt] = new t.globalExt[globalExt]();
      }
    }
  },

  initLocalExtensions: function initLocalExtensions($context) {
    var t = this;
    for (var ext in t.ext) {
      var $els = $context.findOrSelf('.js-' + ext);
      $els.each(function () {
        var fn = new t.ext[ext]($(this));

        $(this).data('obj_' + ext, fn);

        if (app.obj[ext] === undefined) app.obj[ext] = [];
        if ($(this).data('objectName')) {
          app.obj[ext][$(this).data('objectName')] = fn;
        } else {
          app.obj[ext].push(fn);
        }
      });
    }
  },

  getJsData: function getJsData() {
    $('#js-data').find('input').each(function () {
      var name = $(this).attr('name');
      var value = $(this).val();
      app.vars[name] = value;
    });
  },

  ext: {},
  globalExt: {},
  obj: {}
};

$(function () {
  app.init();
});

$.fn.findOrSelf = function (selector) {
  return this.find(selector).add(this.filter(selector));
};

app.globalExt['cookbook'] = function () {
  var api = {};

  var settings = {
    cookieName: 'rf-cookbook',
    expires: 30
  };

  var classes = {
    add: '.js-cookbook-add',
    item: '.js-cookbook-item',
    remove: '.js-cookbook-remove'
  };

  var ids = {
    headerButton: '#cookbook-header-button',
    list: '#cookbook-list',
    message: '#cookbook-message',
    export: '#cookbook-export'
  };

  var $headerButton = $(ids.headerButton);

  if ($headerButton.length) {
    var $list = $(ids.list);
    var $message = $(ids.message);
    var $export = $(ids.export);
    var cookbookData = $headerButton.data();
    var successMessageContent = cookbookData['successMessageContent'];
    var existsMessageContent = cookbookData['existsMessageContent'];
    var cookbookItemUrl = cookbookData['cookbookItemUrl'];
    var cookbookExportUrl = cookbookData['cookbookExportUrl'];
  }

  var init = function init() {
    if ($headerButton.length) {
      addListeners();
    }
  };

  var addListeners = function addListeners() {
    $(document).on('click', classes.add, addClickHandler);
    $(document).on('click', classes.remove, removeClickHandler);
    $export.on('click', exportClickHandler);
    $(window).on('beforeunload', unloadHandler);
  };

  var addClickHandler = function addClickHandler(e) {
    e.preventDefault();
    e.stopPropagation();
    var $button = $(this);
    var recipeId = $button.data('recipeId');
    addRecipe(recipeId, $button);
  };

  var removeClickHandler = function removeClickHandler(e) {
    e.preventDefault();
    e.stopPropagation();
    var $button = $(this);
    var $item = $button.closest(classes.item);
    var recipeId = $item.data('recipeId');
    removeRecipe(recipeId, $item);
  };

  var exportClickHandler = function exportClickHandler() {
    exportCookbook();
  };

  var addRecipe = function addRecipe(recipeId) {
    var $button = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var existingCookie = Cookies.get(settings.cookieName);
    var newCookie = void 0;
    if (existingCookie === undefined) {
      newCookie = [recipeId];
    } else {
      existingCookie = $.parseJSON(existingCookie);
      if ($.inArray(recipeId, existingCookie) == -1) {
        existingCookie.push(recipeId);
        newCookie = existingCookie;
      } else {
        app.obj['message'].showMessage(false, existsMessageContent);
      }
    }
    if (newCookie !== undefined) {
      Cookies.set(settings.cookieName, newCookie, { expires: settings.expires });
      markHeaderButton(newCookie);
      addRecipeToList(recipeId, $button);

      if ($button) {
        app.obj['preloader'].showPreloader($button);
      }
    }
  };

  var removeRecipe = function removeRecipe(recipeId, $recipe) {
    var existingCookie = Cookies.get(settings.cookieName);
    var newCookie = void 0;
    if (existingCookie === undefined) {
      console.log('no cookie?');
    } else {
      existingCookie = $.parseJSON(existingCookie);
      newCookie = $.grep(existingCookie, function (value) {
        return value != recipeId;
      });
    }
    if (newCookie !== undefined) {
      Cookies.set(settings.cookieName, newCookie, { expires: settings.expires });
      markHeaderButton(newCookie);
      removeRecipeFromList($recipe);
    }

    app.obj['scroller']['cookbook'].refreshScroller();
  };

  var markHeaderButton = function markHeaderButton(currentCookie) {
    if (currentCookie === undefined) {
      currentCookie = $.parseJSON(Cookies.get(settings.cookieName));
    }
    var recipeCount = currentCookie.length;
    if (recipeCount) {
      enableHeaderButton(recipeCount);
    } else {
      disableHeaderButton();
      $headerButton.trigger('click');
    }
  };

  var enableHeaderButton = function enableHeaderButton(recipeCount) {
    $headerButton.removeClass(app.states.isDisabled).attr('data-count', recipeCount);
  };

  var disableHeaderButton = function disableHeaderButton(recipeCount) {
    $headerButton.addClass(app.states.isDisabled).attr('data-count', 0);
  };

  var addRecipeToList = function addRecipeToList(recipeId, $button) {
    $.ajax({
      method: 'POST',
      url: cookbookItemUrl,
      data: {
        recipeId: recipeId
      }
    }).done(function (response) {
      recipeCallDone(response, $button);
    });
  };

  var recipeCallDone = function recipeCallDone(response, $button) {
    response = $.parseJSON(response);
    app.obj['message'].showMessage(response['title'], successMessageContent);
    $list.prepend(response['html']);
    app.obj['scroller']['cookbook'].refreshScroller();

    if ($button) {
      app.obj['preloader'].hidePreloader($button);
    }
  };

  var removeRecipeFromList = function removeRecipeFromList($recipe) {
    $recipe.addClass(app.states.isDisabled).velocity('fadeOut', {
      duration: app.settings.duration,
      complete: function complete() {
        $recipe.remove();
      }
    });
  };

  var exportCookbook = function exportCookbook() {
    $.Velocity.hook($message, 'translateY', '20px');
    $message.velocity({
      opacity: 1,
      translateY: '0px'
    }, {
      easing: app.settings.easing,
      duration: app.settings.duration,
      display: 'block'
    });

    window.open(cookbookExportUrl + '&' + $.now(), '_blank');
  };

  var exportCallDone = function exportCallDone(response) {
    app.obj['preloader'].hidePreloader($export);

    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(response);

    link.download = 'Cookbook.pdf';

    link.click();
  };

  var unloadHandler = function unloadHandler(e) {
    $message.velocity({
      opacity: 0,
      translateY: '20px'
    }, {
      easing: app.settings.easing,
      duration: 0,
      display: 'none'
    });
    app.obj['preloader'].hidePreloader($export);
  };

  init();

  return api;
};

app.globalExt['detect-browser'] = function () {
  var dataBrowser = [{ string: navigator.userAgent, subString: 'Edge', identity: 'edge' }, { string: navigator.userAgent, subString: 'MSIE', identity: 'explorer' }, { string: navigator.userAgent, subString: 'Trident', identity: 'explorer' }, { string: navigator.userAgent, subString: 'Firefox', identity: 'firefox' }, { string: navigator.userAgent, subString: 'Opera', identity: 'opera' }, { string: navigator.userAgent, subString: 'OPR', identity: 'opera' }, { string: navigator.userAgent, subString: 'Chrome', identity: 'chrome' }, { string: navigator.userAgent, subString: 'Safari', identity: 'safari' }];

  var versionSearchString = void 0;

  var init = function init() {
    app.vars.browser = searchString(dataBrowser) || 'other';
    app.vars.browserVersion = searchVersion(navigator.userAgent) || searchVersion(navigator.appVersion) || 'unknown';
    app.vars.os = getOs();
    $('html').addClass(app.vars.browser).addClass(app.vars.browser + '-' + app.vars.browserVersion).addClass(app.vars.os);
  };

  var searchString = function searchString(data) {
    for (var i = 0; i < data.length; i++) {
      var dataString = data[i].string;
      versionSearchString = data[i].subString;
      if (dataString.indexOf(data[i].subString) !== -1) {
        return data[i].identity;
      }
    }
  };

  var searchVersion = function searchVersion(dataString) {
    var index = dataString.indexOf(versionSearchString);
    if (index === -1) {
      return;
    }
    var rv = dataString.indexOf('rv:');
    if (versionSearchString === 'Trident' && rv !== -1) {
      return parseFloat(dataString.substring(rv + 3));
    } else {
      return parseFloat(dataString.substring(index + versionSearchString.length + 1));
    }
  };

  var getOs = function getOs() {
    var OSName = 'unknown-os';
    var appVersion = navigator.appVersion;
    if (appVersion.indexOf('Win') !== -1) OSName = 'windows';else if (appVersion.indexOf('Mac') !== -1) OSName = 'macos';else if (appVersion.indexOf('X11') !== -1) OSName = 'unix';else if (appVersion.indexOf('Linux') !== -1) OSName = 'linux';
    return OSName;
  };

  init();
};

app.globalExt['global-events'] = function () {
  var api = {};

  var init = function init() {
    $(document).on('click touchend', documentClickHandler);
  };

  var documentClickHandler = function documentClickHandler(e) {
    $('body').trigger('triggereddocumentclick', [e]);
  };

  init();return api;
};

app.globalExt['global-structure'] = function () {
  var api = {};

  var init = function init() {};

  init();return api;
};

app.globalExt['lazy-load'] = function () {
  var api = {};

  var init = function init() {
    initLazyLoad();
  };

  var initLazyLoad = function initLazyLoad() {
    $(window).lazyLoadXT();
  };

  init();return api;
};

$.extend($.lazyLoadXT, {
  edgeY: 500,
  edgeX: 500,
  visibleOnly: true
});
app.globalExt['message'] = function () {
  var api = {};

  var settings = {
    timeout: 3000
  };

  var templates = {
    message: '<div class="message"><div class="message__title">[[title]]</div><div class="message__content">[[content]]</div></div>'
  };

  api.showMessage = function (title, content) {
    var message = templates.message.replace('[[title]]', title).replace('[[content]]', content);
    var $message = $(message);
    if (!title) {
      $message.find('.message__title').remove();
    }
    var translateDistance = 20;
    if (Gridle.isActive('sm')) {
      translateDistance = -translateDistance;
    }
    $('body').append($message);
    $message.velocity({
      opacity: 1,
      translateY: translateDistance
    }, {
      easing: app.settings.easing,
      duration: app.settings.duration,
      display: 'block'
    });

    setTimeout(function () {
      hideMessage($message);
    }, settings.timeout);
  };

  var hideMessage = function hideMessage($message) {
    $message.velocity({
      opacity: 0,
      translateY: 0
    }, {
      easing: app.settings.easing,
      duration: app.settings.duration,
      display: 'none',
      complete: function complete() {
        $message.remove();
      }
    });
  };

  return api;
};

app.globalExt['overlay'] = function () {

  // elements
  this.$pageCanvas = $(this.classes.pageCanvas);
  this.$overlay = $(this.ids.overlay);
  this.$overlayContainer = $(this.ids.overlayContainer);
  this.$overlayPreloader = $(this.ids.overlayPreloader);

  // vars
  this.overlayOpen = false;
  this.canvasOriginalPosition = 0;

  this.init();
};

app.globalExt['overlay'].prototype = {

  settings: {
    duration: 500
  },

  classes: {
    pageCanvas: '.js-ui-page-canvas',
    closeButton: '.js-overlay-close',
    overlayContent: '.js-overlay-content'
  },

  ids: {
    overlay: '#overlay',
    overlayContainer: '#overlay-container',
    overlayPreloader: '#overlay-preloader'
  },

  init: function init() {
    this.addListeners();
  },

  addListeners: function addListeners() {
    var self = this;
    $('body').on('click', 'a[target="_top"]', { self: this }, this.linkClickHandler);
    $('body').on('click', this.classes.closeButton, { self: this }, this.closeClickHandler);
    $(document).on('click  touchstart', { self: this }, this.documentClickHandler);
  },

  ///////////
  // Handlers

  linkClickHandler: function linkClickHandler(event) {
    event.preventDefault();
    var self = event.data.self;
    var $link = $(this);
    var url = $link.attr('href');
    self.openOverlay(url);
  },

  closeClickHandler: function closeClickHandler(event) {
    var self = event.data.self;
    self.closeOverlay();
  },

  documentClickHandler: function documentClickHandler(event) {
    var self = event.data.self;
    if (self.overlayOpen) {
      if (!$(event.target).closest(self.classes.overlayContent).length) {
        self.closeOverlay();
      }
    }
  },

  ///////
  // Main

  openOverlay: function openOverlay(url) {
    var self = this;
    // app.obj['track'].trackPage();

    // fix canvas
    var canvasOffset = $('html').scrollTop();
    if (canvasOffset == 0) {
      canvasOffset = $('body').scrollTop();
    }

    if (!this.overlayOpen) {
      this.$pageCanvas.css({
        'top': -canvasOffset,
        'position': 'fixed'
      });
      this.canvasOriginalPosition = canvasOffset;
    }

    // show preloader
    if (!this.overlayOpen) {
      this.$overlay.velocity('fadeIn', {
        duration: self.settings.duration,
        complete: function complete() {
          self.overlayOpen = true;
        }
      });
      self.overlayAjaxCall(url);
    } else {
      this.$overlayContainer.velocity('fadeOut', {
        duration: self.settings.duration,
        complete: function complete() {
          self.overlayAjaxCall(url);
        }
      });
      this.$overlayPreloader.velocity('fadeIn', {
        duration: self.settings.duration
      });
    }
  },

  closeOverlay: function closeOverlay() {
    var self = this;
    this.overlayOpen = false;

    // fade out overlay
    this.$overlay.velocity('fadeOut', {
      duration: self.settings.duration,
      complete: function complete() {

        if (self.overlayFirst) {
          // app.obj['track'].trackPage();
          self.overlayFirst = false;
        }

        // unfix canvas
        if (!self.$pageCanvas.length) {
          self.$pageCanvas = $(self.ids.pageCanvas);
        }
        self.$pageCanvas.removeAttr('style');
        $('body, html').scrollTop(self.canvasOriginalPosition);

        // reset overlay
        self.$overlayPreloader.show().css('opacity', 1);
        self.$overlayContainer.empty().hide();
      }
    });
  },

  overlayAjaxCall: function overlayAjaxCall(url) {
    var self = this;
    var overlayPageCall = $.ajax({
      url: url,
      method: 'POST',
      data: { 'ajaxCall': true }
    }).done(function (msg) {
      self.overlayContentLoaded(msg);
    });
  },

  overlayContentLoaded: function overlayContentLoaded(msg) {
    var self = this;
    msg = $.parseJSON(msg);
    msg = msg.html;
    this.$overlayPreloader.velocity('fadeOut', {
      duration: self.settings.duration
    });

    var $html = $(msg);

    this.$overlayContainer.html($html);

    this.$overlayContainer.velocity({
      opacity: 1
    }, {
      display: 'block',
      duration: self.settings.duration,
      complete: function complete() {
        app.parse($html);
        $(window).lazyLoadXT();
      }
    });

    setTimeout(function () {
      $(document).trigger('load');
    }, 100);
  }

};

app.globalExt['preloader'] = function () {
  var api = {};

  var settings = {
    hideDuration: 300
  };

  var states = {
    hasPreloader: 'has-preloader',
    isHidden: 'is-hidden'
  };

  var classes = {
    preloader: '.preloader'
  };

  var templates = {
    preloader: '<div class="preloader"><div class="preloader__inner"></div></div>'
  };

  api.showPreloader = function ($container, position) {
    if ($container.children(classes.preloader).length) return false;
    $container.addClass(states.hasPreloader);
    var $preloader = $(templates.preloader);
    if (position === 'prepend') {
      $container.prepend($preloader);
    } else {
      $container.append($preloader);
    }
  };

  api.hidePreloader = function ($container) {
    var $preloader = $container.find(classes.preloader);
    $container.removeClass(states.hasPreloader);
    if ($preloader.length) {
      $preloader.addClass(states.isHidden);
      setTimeout(function () {
        $preloader.remove();
      }, settings.hideDuration);
    }
  };

  return api;
};

app.globalExt['rellax'] = function () {
  var api = {};

  var rellax;

  var init = function init() {
    if ($('.js-rellax').length) {
      // initRellax()
      addListeners();
    }
  };

  var addListeners = function addListeners() {
    Gridle.on('update', gridleUpdateHandler);
  };

  var gridleUpdateHandler = function gridleUpdateHandler() {
    destroyRellax();
    initRellax();
  };

  var initRellax = function initRellax() {
    if (!Gridle.isActive('lg')) {
      rellax = new Rellax('.js-rellax');
    }
  };

  var destroyRellax = function destroyRellax() {
    if (rellax === undefined) return false;
    rellax.destroy();
    rellax = undefined;
  };

  init();return api;
};

app.globalExt['scroll-to'] = function () {
  var api = {};

  var init = function init() {
    addListeners();
  };

  var addListeners = function addListeners() {
    $(document).on('click', 'a', linkClickHandler);
  };

  var linkClickHandler = function linkClickHandler(e) {
    var href = $(this).attr('href');
    if (href !== undefined) {
      if (href.indexOf('#') >= 0) {
        var hrefSplit = href.split('#');
        var locationHref = window.location.href;
        if (hrefSplit[0] === locationHref || hrefSplit[0] === '') {
          e.preventDefault();
          api.scroll($('#' + hrefSplit[1]));
        }
      }
    }
  };

  api.scroll = function ($element) {
    var headerHeight = $('.header').outerHeight();
    var stickyBarHeight = false;
    if ($('.navbar.js-sticky').length) {
      stickyBarHeight = $('.navbar.js-sticky').outerHeight();
    }

    var offset = -headerHeight;
    if (stickyBarHeight) {
      offset -= stickyBarHeight;
    }

    $element.velocity('scroll', {
      easing: app.settings.easeInOut,
      duration: app.settings.duration * 2,
      offset: offset
    });
  };

  init();
  return api;
};

app.globalExt['throttled-events'] = function () {
  var api = {};

  var resizeTimeout = void 0;

  var settings = {
    timeout: 100
  };

  var init = function init() {
    addListeners();
  };

  var addListeners = function addListeners() {
    $(window).on('resize', windowResizeHandler);
  };

  var windowResizeHandler = function windowResizeHandler() {
    if (resizeTimeout !== undefined) {
      clearTimeout(resizeTimeout);
    }
    setTimeout(function () {
      $(window).trigger('throttledResize');
      resizeTimeout = undefined;
    }, settings.timeout);
  };

  init();return api;
};

app.globalExt['touch-class'] = function () {
  var api = {};

  var init = function init() {
    var deviceAgent = navigator.userAgent.toLowerCase();
    var touchEnabled = 'ontouchstart' in window || navigator.maxTouchPoints;

    if ((deviceAgent.match(/(iphone|ipod|ipad)/) || deviceAgent.match(/(android)/) || deviceAgent.match(/(iemobile)/) || deviceAgent.match(/iphone/i) || deviceAgent.match(/ipad/i) || deviceAgent.match(/ipod/i) || deviceAgent.match(/blackberry/i) || deviceAgent.match(/bada/i)) && touchEnabled) {
      if (document.body.className.indexOf('is-touch') !== -1) {
        return;
      }

      if (document.body.className.length) {
        document.body.className += ' is-touch';
      } else {
        document.body.className = 'is-touch';
      }
    } else {
      if (document.body.className.indexOf('no-touch') !== -1) {
        return;
      }

      if (document.body.className.length) {
        document.body.className += ' no-touch';
      } else {
        document.body.className = 'no-touch';
      }
    }
  };

  init();
  return api;
};

app.globalExt['url-links'] = function () {
  var api = {};

  var init = function init() {
    api.goToDirectLink();
  };

  api.goToDirectLink = function () {
    var hash = window.location.hash.substr(1);
    if (hash !== undefined && hash !== '' && hash) {
      setTimeout(function () {
        app.obj['scroll-to'].scroll($('#' + hash));
      }, 1000);
    }
  };

  init();return api;
};

app.globalExt['youtube-api'] = function () {
  var api = {};

  var init = function init() {
    var tag = document.createElement('script');

    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  };

  init();return api;
};

function onYouTubeIframeAPIReady() {
  app.vars.youtubeready = true;
}

app.ext['calculator'] = function ($el) {
  var api = {};

  var settings = {
    counterDuration: 0.8
  };

  var classes = {
    slider: '.js-calculator-slider',
    counter: '.js-calculator-counter',
    control: '.js-calculator-control'
  };

  var $slider = $(classes.slider, $el);
  var $counter = $(classes.counter, $el);
  var $control = $(classes.control, $el);
  var counter = [];
  var counterValues = [];

  var init = function init() {
    initNoUiSlider();
    initCounters();
    addListeners();
  };

  var addListeners = function addListeners() {
    $control.on('click', controlClickHandler);
    $slider[0].noUiSlider.on('update', sliderUpdateHandler);
  };

  var controlClickHandler = function controlClickHandler() {
    var $control = $(this);
    var value = $control.data('value');
    moveSlider(value);
  };

  var sliderUpdateHandler = function sliderUpdateHandler(e) {
    var value = parseInt(e);
    changeValue(value);
  };

  var initNoUiSlider = function initNoUiSlider() {
    noUiSlider.create($slider[0], {
      start: 3,
      step: 1,
      connect: [true, false],
      range: {
        'min': 1,
        'max': 4
      },
      pips: {
        mode: 'count',
        values: [1],
        density: 40
      }
    });
  };

  var initCounters = function initCounters() {
    var options = {
      useEasing: true,
      useGrouping: true,
      separator: ',',
      decimal: '.'
    };
    $counter.each(function (index, instance) {
      counter[index] = new CountUp(instance, 0, 123, 0, settings.counterDuration, options);
      var counterValue = $(this).data('values');
      counterValues[index] = counterValue.split(',');
    });
  };

  var moveSlider = function moveSlider(value) {
    $slider[0].noUiSlider.set(value);
  };

  var changeValue = function changeValue(value) {
    setCounters(value);
    changeAttr(value);
  };

  var setCounters = function setCounters(value) {
    value = value - 1;
    $counter.each(function (index, instance) {
      counter[index].update(counterValues[index][value]);
    });
  };

  var changeAttr = function changeAttr(value) {
    $el.attr('data-household', value);
  };

  init();return api;
};

app.ext['cookies-banner'] = function ($el) {
  var api = {};

  var init = function init() {
    var $btn = $('.js-cookies-accept');
    $btn.on('click', acceptEvent);
  };

  var acceptEvent = function acceptEvent() {
    Cookies.set('cookies_accepted', 1);
    $el.remove();
  };

  init();
  return api;
};

app.ext['filter'] = function ($el) {
  var api = {};

  var $el = {
    trigger: $('.js-filter-category', $el),
    items: $('.js-filter-item', $el),
    container: $('.video-list__container', $el)
  };

  var init = function init() {

    $el.trigger.on('click', function () {
      $(this).addClass('is-active').siblings().removeClass('is-active');

      var cat = $(this).data('category');
      filterForCat(cat);
    });
  };

  var filterForCat = function filterForCat(cat) {
    $el.container.css({ opacity: 0 });

    setTimeout(function () {
      var count = 0;
      $el.items.each(function () {
        var $i = $(this);
        if (cat.length) {
          if ($i.data('categories').indexOf(cat) === -1) {
            $i.fadeOut(0);
          } else {
            $i.fadeIn(0);
            count++;
          }
        } else {
          $i.fadeIn(0);
          count = $el.items.length;
        }
      });

      $('.js-load-total').text(count);
      setTimeout(function () {
        $el.container.css({ opacity: 1 });
      }, 200);
    }, 200);
  };

  init();return api;
};

app.ext['hero-video'] = function ($el) {
  var api = {};

  var settings = {
    youtubeUrl: 'https://www.youtube.com/embed/',
    youtubeOptions: '?autoplay=1&controls=0&modestbranding=1&rel=0&showinfo=0'
  };

  var classes = {
    play: '.js-hero-video-play',
    container: '.js-hero-video-container',
    iframe: '.js-hero-video-iframe',
    close: '.js-hero-video-close'
  };

  var states = {
    isPlaying: 'is-playing',
    isClosing: 'is-closing'
  };

  var $play = $(classes.play, $el);
  var $container = $(classes.container, $el);
  var $iframe = $(classes.iframe, $el);
  var $close = $(classes.close, $el);

  var videoId = $el.data('videoId');

  var init = function init() {
    addListeners();
  };

  var addListeners = function addListeners() {
    $play.on('click', playClickHandler);
    $close.on('click', closeClickHandler);
  };

  var playClickHandler = function playClickHandler() {
    startVideo();
  };
  var closeClickHandler = function closeClickHandler() {
    closeVideo();
  };

  var startVideo = function startVideo() {
    $el.addClass(states.isPlaying);
    $iframe.attr('src', settings.youtubeUrl + videoId + settings.youtubeOptions);
    $el.trigger('hero-video-start');
  };

  var closeVideo = function closeVideo() {
    $el.removeClass(states.isPlaying);
    $el.addClass(states.isClosing);
    setTimeout(function () {
      $el.removeClass(states.isClosing);
      $iframe.attr('src', '');
      $el.trigger('hero-video-close');
    }, 1000);
  };

  init();return api;
};

app.ext['lightbox'] = function ($el) {
  var api = {};

  var type = $el.data('lightboxType');

  var init = function init() {
    api.initMagnific();
  };

  api.initMagnific = function () {
    var isOpen = false;
    var tracking = $el.data('lightbox-pagination-tracking');

    $el.magnificPopup({
      delegate: '.js-lightbox-trigger',
      type: type,
      image: {
        titleSrc: 'data-title'
      },
      gallery: { enabled: true },
      callbacks: {
        open: function open() {
          isOpen = true;
        },
        close: function close() {
          isOpen = false;
        },
        change: function change() {
          // only trigger tracking if lightbox is open (open event is triggered after change event)
          if (isOpen && tracking && ga) {
            ga('send', 'event', tracking);
          }
        }
      }
    });
  };

  init();return api;
};

app.ext['line-split'] = function ($el) {
  var api = {};

  var init = function init() {
    addListeners();
    splitLines();
    setTimeout(function () {
      // splitLines()
    }, 100);
  };

  var addListeners = function addListeners() {
    $(window).on('throttledResize', windowResizeHandler);
  };

  var windowResizeHandler = function windowResizeHandler() {
    splitLines();
  };

  var splitLines = function splitLines() {
    $el.text($el.text());
    $el.breakLines();
  };

  init();return api;
};

(function ($) {
  'use strict';

  $.fn['breakLines'] = function (options) {
    var defaults = {
      'lineBreakHtml': '<br />',
      'wrapElement': '<span></span>',
      'atStartOfBlocks': false,
      'insideStartOfTags': false,
      'widthToWrapTo': false
    };
    options = $.extend(defaults, options);
    return this.each(function () {
      var _this = this;

      var textNodes,
          // all textNodes (as opposed to elements)
      copy,
          // jQuery object for copy of the current element
      el = $(this),
          // just so we know what we're working with
      recurseThroughNodes,
          // function to do the spitting/moving
      insertedBreaks,
          // jQuery collection of inserted line breaks
      styleAttr,
          // Backup of the element's style attribute
      textContainer = [],
          textContainerIndex = -1;

      styleAttr = $(this).attr('style');
      el.css('height', 'auto');

      // If the user wants to wrap to a different width than the one
      // set by CSS
      if (options.widthToWrapTo !== false) {
        el.css('width', options.widthToWrapTo);
      }

      recurseThroughNodes = function recurseThroughNodes(currentNode, copyNode) {
        //why would you use contents() when there are no html nodes inside? just text???

        // $(copyNode).contents().each(function () {
        //   var nextCopy,
        //     currentHeight

        //   currentHeight = el.height()

        //   $(this).appendTo(currentNode)

        //   // console.log($(this));

        //   if (el.height() !== currentHeight) {
        //     textContainerIndex++
        //     textContainer[textContainerIndex] = $(this)[0].data
        //   } else {
        //     textContainer[textContainerIndex] += $(this)[0].data
        //   }
        // })

        var splited = $(copyNode).html().split(" ");
        $.each(splited, function (index, value) {

          var nextCopy, currentHeight;

          currentHeight = el.height();

          var textNode = document.createTextNode(value);

          $(textNode).appendTo(currentNode);

          if (el.height() !== currentHeight) {
            textContainerIndex++;
            textContainer[textContainerIndex] = value;
          } else {
            textContainer[textContainerIndex] += ' ' + value;
          }
        });
      };

      // Clone the element and empty the original
      copy = el.clone().insertAfter(el);
      el.empty();

      // Get text nodes: .find gets all non-textNode elements, contents
      // gets all child nodes (inc textNodes) and the not() part removes
      // all non-textNodes.
      textNodes = copy.find('*').add(copy).contents().not(copy.find('*'));

      // Split each textNode into individual textNodes, one for each
      // word
      textNodes.each(function (index, lastNode) {
        var startOfWord = /\W\b/,
            result;
        while (startOfWord.exec(lastNode.nodeValue) !== null) {
          result = startOfWord.exec(lastNode.nodeValue);
          // startOfWord matches the character before the start of a
          // word, so need to add 1.
          lastNode = lastNode.splitText(result.index + 1);
        }
      });

      // Go through all the nodes, going recursively deeper, until we've
      // inserted line breaks in all the text nodes

      recurseThroughNodes(this, copy);

      // We don't need the copy anymore
      copy.remove();

      // Clean up breaks at start of tags as per options
      // insertedBreaks.filter(':first-child').each(function () {
      //   if (!options.atStartOfBlocks &&
      //           $(this).parent().css('display') === 'block') {
      //     $(this).remove()
      //   }
      //   if (!options.insideStartOfTags) {
      //     $(this).insertBefore($(this).parent())
      //   }
      // })

      $(this).html('');
      $.each(textContainer, function (index, value) {
        $(_this).append('<span>' + value + '</span>');
      });
      // Restore backed-up style attribute
      $(this).attr('style', styleAttr);
    });
  };
})(jQuery);

app.ext['load'] = function ($el) {
  var api = {};

  var classes = {
    category: '.js-load-category',
    sorting: '.js-load-sorting',
    container: '.js-load-container',
    more: '.js-load-more',
    item: '.js-load-item',
    total: '.js-load-total',
    categoryLabel: '.js-load-category-label',
    sortingLabel: '.js-load-sorting-label'
  };

  var states = {
    isNew: 'is-new',
    isDimmed: 'is-dimmed',
    isNoResults: 'is-no-results'
  };

  var $category = $(classes.category, $el);
  var $sorting = $(classes.sorting, $el);
  var $container = $(classes.container, $el);
  var $more = $(classes.more, $el);
  var $total = $(classes.total, $el);
  var $categoryLabel = $(classes.categoryLabel, $el);
  var $sortingLabel = $(classes.sortingLabel, $el);

  var category;
  var categoryLabel;
  var categoryParams;
  var categoryParamsListeners = [];
  var sorting = 'DESC';
  var sortingLabel;
  var objectOptions = $el.data();
  var type = objectOptions['loadType'];
  var loadUrl = app.vars[type + '-url'];
  var staticContent = objectOptions['staticContent'];
  var initialLoadStarted = false;
  var initialLoadDone = false;
  var limit;
  var offset;
  var loading = false;

  var init = function init() {
    addListeners();
    getInitialCategory();
    setInitialLoad();
    setTimeout(function () {
      checkHashFilter();
    }, 100);
  };

  var setupParameters = function setupParameters() {
    if (type === 'partners') {
      offset = 2;
      limit = 6;
    } else if (type === 'social-hub') {
      limit = 10;
    } else if (type === 'recipes') {
      limit = 8;
    } else if (type === 'press-releases') {
      offset = 5;
      limit = 6;
    } else if (type === 'press-pictures') {
      offset = 8;
      limit = 8;
    } else if (type === 'press-videos') {
      offset = 6;
      limit = 6;
    } else if (type === 'stories') {
      offset = 10;
      limit = 9;
    }
  };

  var loadInitialContent = function loadInitialContent() {
    offset = 0;
    if (type === 'social-hub') {
      limit = 5;
    } else if (type === 'recipes') {
      limit = 8;
    } else {
      limit = 9;
    }
    loadContent('replace');
    initialLoadStarted = true;
  };

  var setInitialLoad = function setInitialLoad() {
    if (staticContent) {
      initialLoadDone = true;
      setupParameters();
    } else {
      loadInitialContent();
    }
  };

  var addListeners = function addListeners() {
    $category.on('click', categoryClickHandler);
    $sorting.on('click', sortingClickHandler);
    $more.on('click', moreClickHandler);
    $el.on('initialLoad', elInitialLoadHandler);
  };

  var categoryClickHandler = function categoryClickHandler(e) {
    e.preventDefault();
    var $this = $(this);
    if ($this.hasClass(app.states.isActive)) return false;
    category = $this.data('category');
    categoryLabel = $this.data('categoryLabel');
    if (category !== '' && category !== undefined) {
      window.location.hash = category;
    } else {
      history.pushState("", document.title, window.location.pathname);
    }
    getCategoryParams($this);
    var mode = 'replace';
    loadContent(mode);
  };

  var sortingClickHandler = function sortingClickHandler(e) {
    e.preventDefault();
    var $this = $(this);
    if ($this.hasClass(app.states.isActive)) return false;
    sorting = $this.data('sorting');
    sortingLabel = $this.data('sortingLabel');
    var mode = 'replace';
    loadContent(mode);
  };

  var checkHashFilter = function checkHashFilter() {
    var hash = window.location.hash;
    if (hash.indexOf('#') === 0) {
      hash = hash.split('#')[1];
      $(classes.category + '[data-category="' + hash + '"]').trigger('click').addClass('is-active');

      setTimeout(function () {
        $('html, body').animate({
          scrollTop: $('.recipes__filters').offset().top - 145
        });
      }, 400);
    }
  };

  var moreClickHandler = function moreClickHandler(e) {
    e.preventDefault();
    var $this = $(this);
    var mode = 'more';
    loadContent(mode);
  };

  var paramsChangeHandler = function paramsChangeHandler() {
    var $activeCategory = $category.filter('.' + app.states.isActive);
    getCategoryParams($activeCategory);
    var mode = 'replace';
    loadContent(mode);
  };

  var elOnScreenHandler = function elOnScreenHandler(e) {
    if (initialLoadStarted || initialLoadDone) return false;
    api.loadInitialContent();
  };

  var elInitialLoadHandler = function elInitialLoadHandler(e) {
    if (initialLoadStarted || initialLoadDone) return false;
    api.loadInitialContent();
  };

  var loadContent = function loadContent(mode) {
    if (loading) return false;
    loading = true;
    var $preloaderContainer;
    var preloaderPosition;

    if (mode === 'replace') {
      $preloaderContainer = $container;
      preloaderPosition = 'append';
      dimContainer();
      offset = 0;
    } else {
      $preloaderContainer = $more;
      preloaderPosition = 'prepend';
    }

    app.obj['preloader'].showPreloader($preloaderContainer, preloaderPosition);

    $.ajax({
      method: 'POST',
      url: loadUrl,
      data: {
        limit: limit,
        offset: offset,
        category: category,
        sorting: sorting,
        categoryParams: categoryParams,
        ajaxCall: true
      }
    }).done(function (response) {
      contentLoaded(response, mode, $preloaderContainer);
    });
  };

  var contentLoaded = function contentLoaded(response, mode, $preloaderContainer) {
    response = $.parseJSON(response);
    var $html = $(response['html']);
    loading = false;

    if (type === 'recipes') {
      $html = switchDoubleItems($html);
    }

    var $htmlWrapped = $html.wrap('<div></div>');
    var $items = $html.findOrSelf(classes.item);

    app.parse($htmlWrapped);

    app.obj['preloader'].hidePreloader($preloaderContainer);

    if (mode === 'replace') {
      markCategoryButton();
      updateCategoryLabel();
      markSortingButton();
      updateSortingLabel();
      $container.velocity({
        opacity: 0
      }, {
        duration: app.settings.duration,
        complete: function complete() {
          $container.html($html).removeClass(states.isDimmed);

          if (type === 'press-pictures') {
            app.obj['masonry']['press-pictures'].layoutElements();
          }
          $container.velocity({
            opacity: 1
          }, {
            duration: app.settings.duration
          });
        }
      });
    } else if (mode === 'more') {
      $items.each(function () {
        $(this).addClass(states.isNew);
      });
      $container.append($html);
      $(window).trigger('resize');

      $items.each(function (index) {
        var $item = $(this);
        setTimeout(function () {
          $item.removeClass(states.isNew);
        }, 50 * index);
      });

      if (type === 'press-pictures') {
        app.obj['masonry']['press-pictures'].appendElements($html);
      }
    }

    var count = parseInt(response['count']);
    var total = parseInt(response['total']);
    var special = 0;

    offset += count;

    toggleMore(total, special);
    updateTotal(total);
    updateNoResults(total);

    $(window).lazyLoadXT();
    setTimeout(function () {
      $(window).lazyLoadXT();
    }, 1000);

    if (!initialLoadDone) {
      initialLoadDone = true;
      setupParameters();
    }
  };

  var getInitialCategory = function getInitialCategory() {
    category = getActiveCategory();
  };

  var getActiveCategory = function getActiveCategory() {
    var $activeCategory = $category.filter('.' + app.states.isActive);
    getCategoryParams($activeCategory);

    var category;
    if ($activeCategory.length) {
      category = $activeCategory.data('category');
    } else {
      category = '';
    }
    return category;
  };

  var getCategoryParams = function getCategoryParams($category) {
    var paramsId = $category.data('categoryParameters');
    if (paramsId !== undefined) {
      categoryParams = $(paramsId).val();
      if (categoryParamsListeners.indexOf(paramsId) === -1) {
        categoryParamsListeners.push(paramsId);
        $(paramsId).on('change', paramsChangeHandler);
      }
    } else {
      categoryParams = '';
    }
  };

  var dimContainer = function dimContainer() {
    $container.addClass(states.isDimmed);
  };

  var toggleMore = function toggleMore(total, special) {
    if (offset + special >= total) {
      $more.velocity('slideUp', {
        duration: app.settings.duration
      });
    } else {
      $more.show();
    }
  };

  var markCategoryButton = function markCategoryButton() {
    var $currentCategory = $category.filter('.' + app.states.isActive);
    var $newCategory = $category.filter('[data-category="' + category + '"]');

    $currentCategory.removeClass(app.states.isActive);
    $newCategory.addClass(app.states.isActive);
  };

  var markSortingButton = function markSortingButton() {
    var $currentSorting = $sorting.filter('.' + app.states.isActive);
    var $newSorting = $sorting.filter('[data-sorting="' + sorting + '"]');

    $currentSorting.removeClass(app.states.isActive);
    $newSorting.addClass(app.states.isActive);
  };

  var updateTotal = function updateTotal(total) {
    $total.text(total);
  };

  var switchDoubleItems = function switchDoubleItems($html) {
    $html.each(function (index, value) {
      var $currentItem = $(this);
      var itemSwitch = $currentItem.hasClass('is-switch');
      if (itemSwitch) {
        var previous = $html[index - 1];
        $html[index - 1] = value;
        $html[index] = previous;
      }
    });
    return $html;
  };

  var updateNoResults = function updateNoResults(total) {
    if (total > 0) {
      $el.removeClass(states.isNoResults);
    } else {
      $el.addClass(states.isNoResults);
    }
  };

  var updateCategoryLabel = function updateCategoryLabel() {
    if ($categoryLabel.length) {
      $categoryLabel.text(categoryLabel);
    }
  };

  var updateSortingLabel = function updateSortingLabel() {
    if ($sortingLabel.length) {
      $sortingLabel.text(sortingLabel);
    }
  };

  init();return api;
};

app.ext['local-structure'] = function ($el) {
  var api = {};

  var init = function init() {};

  init();return api;
};

app.ext['masonry'] = function ($el) {
  var api = {};

  var init = function init() {
    initMasonry();
  };

  var initMasonry = function initMasonry() {
    $el.masonry({
      transitionDuration: 0
    });
    $el.imagesLoaded().progress(function () {
      $el.masonry('layout');
    });
  };

  api.appendElements = function ($elements) {
    $el.imagesLoaded(function () {
      $el.masonry('appended', $elements);
    });
  };

  api.layoutElements = function () {
    // $el.masonry();

    $el.masonry('destroy');
    $el.imagesLoaded(function () {
      $el.masonry();
    });
  };

  init();return api;
};

app.ext['scroll-nav'] = function ($el) {
  var api = {};

  var classes = {
    link: '.js-scroll-nav-link'
  };

  var $link = $(classes.link, $el);

  var positions = [];
  var offset = void 0;
  var scrollTimeout = void 0;
  var activeIndex = false;

  var init = function init() {
    addListeners();
    getElementPositions();
  };

  var addListeners = function addListeners() {
    $link.on('click', linkClickHandler);
    $(window).on('scroll', windowScrollHandler);
  };

  var getElementPositions = function getElementPositions() {
    $link.each(function () {
      var $this = $(this);
      var href = $this.attr('href');
      var position = $(href).offset().top;
      positions.push(position);
    });

    offset = $('.header').outerHeight() + $el.outerHeight() + 35;

    // console.log(offset)
  };

  var linkClickHandler = function linkClickHandler(e) {
    e.preventDefault();
    var $this = $(this);
    var href = $this.attr('href');
    app.obj['scroll-to'].scroll($(href));
  };

  var windowScrollHandler = function windowScrollHandler() {
    if (scrollTimeout !== undefined) {
      clearTimeout(scrollTimeout);
    }

    scrollTimeout = setTimeout(function () {
      checkPosition();
      scrollTimeout = undefined;
    }, 50);
  };

  var checkPosition = function checkPosition() {
    var currentPosition = $(window).scrollTop();
    var currentIndex = false;
    $.each(positions, function (index, value) {
      if (currentPosition >= value - offset) {
        currentIndex = index;
      }
    });

    if (currentIndex !== false && currentIndex !== activeIndex) {
      markLink(currentIndex);
    }
    if (currentIndex === false && activeIndex !== false) {
      unmarkLink();
    }
  };

  var markLink = function markLink(index) {
    var $newLink = $link.eq(index);
    $newLink.siblings('.' + app.states.isActive).removeClass(app.states.isActive);
    $newLink.addClass(app.states.isActive);
    activeIndex = index;
  };
  var unmarkLink = function unmarkLink() {
    $link.eq(activeIndex).removeClass(app.states.isActive);
    activeIndex = false;
  };

  init();return api;
};

app.ext['scroller'] = function ($el) {
  var api = {};

  var scroller = void 0;

  var init = function init() {
    initIScroll();
  };

  var initIScroll = function initIScroll() {
    scroller = new IScroll($el[0], {
      mouseWheel: true,
      scrollbars: true,
      useTransition: false,
      interactiveScrollbars: true,
      click: false,
      preventDefaultException: { '*': /.*/ }
    });
  };

  api.refreshScroller = function () {
    scroller.refresh();
  };

  init();return api;
};

app.ext['search'] = function ($el) {
  var api = {};

  var settings = {
    apiUrl: 'http://grundig-respect-food.public.devlocal/api/search'
  };

  var classes = {
    input: '.js-search-input',
    close: '.js-search-close',
    results: '.js-search-results',
    resultsCount: '.js-search-result-count',
    pageCanvas: '.js-ui-page-canvas',
    trigger: '.js-search-trigger',
    error: '.js-search-error',

    loadMoreSearch: '.js-load-more-search'
  };

  var states = {
    isOpen: 'is-open'
  };

  var $input = $(classes.input, $el);
  var $close = $(classes.close, $el);
  var $results = $(classes.results, $el);
  var $resultsCount = $(classes.resultsCount, $el);
  var $trigger = $(classes.trigger);
  var $pageCanvas = $(classes.pageCanvas);

  var $error = $(classes.error);

  var resultLoaded = false;
  var canvasOriginalPosition = 0;

  var searchString = '';

  var init = function init() {

    addListeners();

    checkIfSearchURL();
  };

  var addListeners = function addListeners() {
    $input.on('keypress', searchHandler);
    $close.on('click', closeClickHandler);
    $trigger.bind('resetSearch', resetSearch);

    $el.on('click', classes.loadMoreSearch, moreClickHandler);

    $(window).resize(resizeEventHandler);
  };

  var resizeEventHandler = function resizeEventHandler() {
    $results.css('min-height', $(window).height() - $('.js-header').outerHeight() - $('.js-search-header').outerHeight() + 'px');
  };

  var searchHandler = function searchHandler(e) {

    //check if length is at least 3
    if (e.which == 13) {

      if ($(this).val().length > 2) {

        $error.removeClass(states.isOpen);

        searchString = $(this).val();
        doSearch(searchString);
      } else {
        $error.addClass(states.isOpen);
      }
    }
  };

  // const triggerClickHandler = function(e) {

  // 	if ($trigger.hasClass(states.isOpen)) {

  // 		alert('closing search');

  // 		var url = window.location.href.split('?search')[0];
  // 		history.pushState({}, '', url);

  // 		searchString = '';
  // 		$input.val('');
  // 		$results.html('').removeAttr('style');
  // 		$resultsCount.html('').parent().hide();

  // 		unFixCanvas();

  // 	}
  // }

  var resetSearch = function resetSearch() {
    var url = window.location.href.split('?search')[0];
    history.pushState({}, '', url);

    searchString = '';
    $input.val('');
    $results.html('').removeAttr('style');
    $resultsCount.html('').parent().hide();

    $.extend($.lazyLoadXT, {
      scrollContainer: 'window',
      forceLoad: false
    });

    unFixCanvas();
  };

  var closeClickHandler = function closeClickHandler() {
    $trigger.trigger('resetSearch');
    $trigger.click();
  };

  var doSearch = function doSearch(searchString) {
    app.obj['preloader'].showPreloader($input.parent());

    $.ajax({
      url: app.vars['search-url'],
      method: 'POST',
      data: {
        searchString: searchString
      }
    }).done(function (response) {
      app.obj['preloader'].hidePreloader($input.parent());

      fixCanvas();

      var responseJSON = $.parseJSON(response);

      $results.html(responseJSON['html']);
      $resultsCount.html(responseJSON['total']).parent().show();

      history.pushState({}, '', window.location.href.split('?search')[0] + '?search=' + searchString);

      $results.css('min-height', $(window).height() - $('.js-header').outerHeight() - $('.js-search-header').outerHeight() + 'px');

      $.extend($.lazyLoadXT, {
        scrollContainer: '.js-search',
        forceLoad: true
      });

      setTimeout(function () {
        $('.js-search').find('[data-bg]').lazyLoadXT();
        $('.js-search').trigger('scroll');
      }, 500);
    });
  };

  var fixCanvas = function fixCanvas() {
    var canvasOffset = $('html').scrollTop();
    if (canvasOffset == 0) {
      canvasOffset = $('body').scrollTop();
    }

    $pageCanvas.css({
      'top': -canvasOffset,
      'position': 'fixed'
    });
    $pageCanvas.attr('data-offset', canvasOffset);
  };

  var unFixCanvas = function unFixCanvas() {
    $pageCanvas.removeAttr('style');
    $('body, html').scrollTop($pageCanvas.attr('data-offset'));
    $pageCanvas.removeAttr('data-offset');
  };

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  };

  var checkIfSearchURL = function checkIfSearchURL() {

    searchString = getUrlParameter('search');

    if (searchString) {

      setTimeout(function () {
        $trigger.click();

        $('.js-search-input').val(searchString);
        doSearch(searchString);
      }, 250);
    }
  };

  var moreClickHandler = function moreClickHandler(e) {

    var $this = $(e.currentTarget);

    app.obj['preloader'].showPreloader($this);

    $.ajax({
      url: app.vars[$this.attr('data-url')],
      method: 'POST',
      data: {
        searchString: searchString,
        offset: $this.attr('data-offset'),
        isLoadMore: true
      }
    }).done(function (response) {
      var responseJSON = $.parseJSON(response);

      $($this.data('container')).append(responseJSON['html']);

      if (!responseJSON['showMoreButton']) {
        $this.remove();
      } else {
        app.obj['preloader'].hidePreloader($this);
        $this.attr('data-offset', responseJSON['shownPosts']);
      }

      setTimeout(function () {
        $('.js-search').find('[data-bg]').lazyLoadXT();

        $('.js-search').trigger('scroll');
      }, 500);
    });
  };

  init();return api;
};

app.ext['single-video'] = function ($el) {
  var api = {};

  var player = void 0;

  var videoUrl = $el.data('yt-url');
  var videoId = void 0;

  var playerEl = $el.find('#video-wrapper')[0];

  var init = function init() {

    videoId = videoUrl.split('=')[1];

    setTimeout(function () {
      if (app.vars.youtubeready) {
        createYTPlayer();
      }
    }, 200);
  };

  var createYTPlayer = function createYTPlayer() {
    player = new YT.Player(playerEl, {
      videoId: videoId
    });
  };

  init();return api;
};

app.ext['slider'] = function ($el) {
  var api = {};

  var options = $el.data();

  var defaults = {
    pagination: false,
    paginationType: 'bullets',
    prevButton: null,
    nextButton: null,
    spaceBetween: 0,
    speed: 300,
    autoplay: false,
    slideToClickedSlide: false,
    loop: false,
    count: false,
    grabCursor: false,
    autoHeight: false,
    parallax: false
  };

  var pagination = options['pagination'] !== undefined ? options['pagination'] : defaults.pagination;
  var paginationType = options['paginationType'] !== undefined ? options['paginationType'] : defaults.paginationType;
  var prevButton = options['prevButton'] !== undefined ? options['prevButton'] : defaults.prevButton;
  var nextButton = options['nextButton'] !== undefined ? options['nextButton'] : defaults.nextButton;
  var spaceBetween = options['spaceBetween'] !== undefined ? options['spaceBetween'] : defaults.spaceBetween;
  var speed = options['speed'] !== undefined ? options['speed'] : defaults.speed;
  var autoplay = options['autoplay'] !== undefined ? options['autoplay'] : defaults.autoplay;
  var slideToClickedSlide = options['slideToClickedSlide'] || defaults.slideToClickedSlide;
  var loop = options['loop'] || defaults.loop;
  var count = options['count'] || defaults.count;
  var grabCursor = options['grabCursor'] || defaults.grabCursor;
  var autoHeight = options['autoHeight'] || defaults.autoHeight;
  var parallax = options['parallax'] || defaults.parallax;

  var slider = void 0;

  var init = function init() {
    initSlider();
    addListeners();
  };

  var initSlider = function initSlider() {
    slider = new Swiper($el, {
      paginationClickable: true,
      slidesPerView: 'auto',
      pagination: pagination,
      paginationType: paginationType,
      spaceBetween: spaceBetween,
      prevButton: prevButton,
      nextButton: nextButton,
      speed: speed,
      autoplay: autoplay,
      autoplayDisableOnInteraction: false,
      slideToClickedSlide: slideToClickedSlide,
      loop: loop,
      grabCursor: grabCursor,
      autoHeight: autoHeight,
      parallax: parallax,
      keyboardControl: true,
      onInit: function onInit() {
        sliderInitialized();
      },
      onAfterResize: function onAfterResize() {
        sliderResized();
      },
      onSlideChangeStart: function onSlideChangeStart(e) {
        slideChangeStart(e);
      },
      onSlideChangeEnd: function onSlideChangeEnd(e) {
        slideChangeEnd(e);
      }
    });
  };

  var addListeners = function addListeners() {
    $el.on('hero-video-start', stopAutoplay);
    $el.on('hero-video-close', startAutoplay);
  };

  var sliderInitialized = function sliderInitialized() {
    if (count) {
      implementCount();
    }
  };

  var startAutoplay = function startAutoplay() {
    if (autoplay && slider) {
      slider.startAutoplay();
    }
  };

  var stopAutoplay = function stopAutoplay() {
    if (autoplay && slider) {
      slider.stopAutoplay();
    }
  };

  var sliderResized = function sliderResized() {
    if (count) {
      implementCount();
    }
  };

  var slideChangeStart = function slideChangeStart(e) {
    updateLazyLoad();
  };

  var slideChangeEnd = function slideChangeEnd(e) {
    updateLazyLoad();
  };

  var updateLazyLoad = function updateLazyLoad() {
    $(window).trigger('resize');
  };

  var implementCount = function implementCount() {
    var $bullet = $('.swiper-pagination-bullet', $el).eq(count);
    $bullet.addClass(app.states.isHidden);
  };

  // const blockSlide = (activeIndex) => {
  //   if (activeIndex === count) {
  //     console.log('block')
  //     return false
  //   }
  // }

  init();
  return api;
};

app.ext['social'] = function ($el) {
  var api = {};

  var config = {
    default: {
      popupWidth: 520,
      popupHeight: 350,
      urlKey: 'url',
      textKey: 'text'
    },
    facebook: {
      url: 'https://www.facebook.com/sharer/sharer.php',
      urlKey: 'u'
    },
    twitter: {
      url: 'https://twitter.com/intent/tweet/'
    },
    linkedin: {
      url: 'https://www.linkedin.com/shareArticle'
    },
    googleplus: {
      url: 'https://plus.google.com/share'
    },
    pinterest: {
      url: 'https://www.pinterest.com/pin/create/button/',
      popupHeight: 'full',
      popupWidth: 'half'
    },
    whatsapp: {
      url: 'https://api.whatsapp.com/send'
    },
    email: {
      url: 'mailto:?subject=Ruhun%20Doysun&body=L%C4%B0MONLU%20TART%20http://www.ruhundoysun.com/tarifler/limonlu-tart.html'
    }
  };

  var type = $el.data('type') || 'facebook';
  var shareUrl = $el.data('shareUrl') || escape(window.location.href);
  var mediaUrl = $el.data('mediaUrl') || false;
  var content = $el.data('content') || false;
  var configMedia = void 0;

  var init = function init() {
    addListeners();
    setupConfig();
  };

  var setupConfig = function setupConfig() {
    configMedia = $.extend({}, config.default, config[type]);

    if (!configMedia.url) {
      console.error('Sharing is not setup for "' + type + '"');
      return;
    };
  };

  var addListeners = function addListeners() {
    $el.on('click', elClickHandler);
  };

  var elClickHandler = function elClickHandler(e) {
    e.preventDefault();
    showPopup();
  };

  var showPopup = function showPopup() {
    var url = configMedia.url;

    // Add parameter
    var parameter = [];
    parameter.push(configMedia.urlKey + '=' + shareUrl);
    if (mediaUrl) {
      parameter.push('media' + '=' + mediaUrl);
    }
    if (content) {
      parameter.push(configMedia.textKey + '=' + content);
    }
    parameter = '?' + parameter.join('&');
    url += parameter;

    if (type === 'email') {
      url = 'mailto:?';
      url += 'subject=' + encodeURIComponent(content);
      url += '&body=' + encodeURIComponent(content) + '%0A%0A' + shareUrl;
      window.location.href = url;
      return;
    }

    // Convert "string" to height
    if (configMedia.popupHeight == 'full') {
      configMedia.popupHeight = $(window).height();
    };

    if (configMedia.popupWidth == 'half') {
      configMedia.popupWidth = $(window).width() / 2;
    };

    var windowLeft = window.screenLeft ? window.screenLeft : window.screenX;
    var windowTop = window.screenTop ? window.screenTop : window.screenY;

    var top = windowTop + ($(window).height() / 2 - configMedia.popupHeight / 2);
    var left = windowLeft + ($(window).width() / 2 - configMedia.popupWidth / 2);

    window.open(url, 'sharePopUp', 'height=' + configMedia.popupHeight + ', width=' + configMedia.popupWidth + ', top=' + top + ', left=' + left + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
  };

  init();return api;
};

app.ext['sticky'] = function ($el) {
  var api = {};

  var init = function init() {
    initStickyKit();
  };

  var initStickyKit = function initStickyKit() {
    var headerHeight = $('.header').outerHeight();
    var offset = headerHeight;
    $el.stick_in_parent({
      offset_top: offset
    });
  };

  init();return api;
};

app.ext['survey-trigger'] = function ($el) {
  var api = {};

  var settings = {
    cookieName: 'rf-survey-taken',
    cookieNamePopup: 'rf-survey-opened',
    expires: 30
  };

  var timeoutDuration = $el.data('timeout');
  var callUrl = $el.data('url');

  var init = function init() {
    initSurvey();
  };

  var initSurvey = function initSurvey() {
    setTimeout(function () {
      var currentCookiePopup = Cookies.get(settings.cookieNamePopup);
      if (currentCookiePopup != 1) {
        app.obj['overlay'].openOverlay(callUrl);
        Cookies.set(settings.cookieNamePopup, 1, { expires: settings.expires });
      }
    }, timeoutDuration * 1000);
  };

  init();return api;
};

app.ext['survey'] = function ($el) {
  var api = {};

  var settings = {
    apiUrl: 'https://www.respectfood.com/survey/votes.php',
    cookieName: 'rf-survey-taken',
    cookieNamePopup: 'rf-survey-opened',
    expires: 30,
    multipleVoting: true
  };

  var classes = {
    main: '.js-survey-main',
    mainContainer: '.js-survey-main-container',
    row: '.js-survey-row',
    rowLabel: '.js-survey-row-label',
    rowPercentage: '.js-survey-row-percentage',
    rowRadio: '.js-survey-row-radio'
  };

  var states = {
    isTemplate: 'is-template',
    isResults: 'is-results',
    isLoaded: 'is-loaded'
  };

  var voted = false;

  var $main = $(classes.main, $el);
  var $mainContainer = $(classes.mainContainer, $el);
  var $rowTemplate = $(classes.row, $el);
  var $row = $(classes.row, $el);

  var init = function init() {
    getVotes();
    addListeners();
  };

  var addListeners = function addListeners() {
    $el.on('click', classes.row, rowClickHandler);
  };

  var rowClickHandler = function rowClickHandler() {
    var id = $(this).data('id');
    sendVote(id);
  };

  var getVotes = function getVotes() {
    app.obj['preloader'].showPreloader($mainContainer);
    Cookies.set(settings.cookieNamePopup, 1, { expires: settings.expires });

    $.ajax({
      url: settings.apiUrl,
      method: 'GET'
    }).done(function (response) {
      getVotesDone(response);
      app.obj['preloader'].hidePreloader($mainContainer);
    });
  };

  var getVotesDone = function getVotesDone(response) {
    createList(response['terms']);
  };

  var createList = function createList(terms) {
    $.each(terms, function (term_index, term) {
      var $newRow = $rowTemplate.clone();
      $newRow.attr('data-id', term['id']).removeClass(states.isTemplate).find(classes.rowLabel).text(term['name_en']);

      $main.append($newRow);
    });

    $main.addClass(states.isLoaded);
    $row = $(classes.row, $el);

    if (!settings.multipleVoting) {
      var currentCookie = Cookies.get(settings.cookieName);
      if (currentCookie == 1) {
        voted = true;
        showResults(terms);
      }
    }
  };

  var sendVote = function sendVote(id) {
    if (voted) return false;

    var $currentRow = $row.filter('[data-id="' + id + '"]');
    var $currentRowRadio = $currentRow.find(classes.rowRadio);
    app.obj['preloader'].showPreloader($currentRowRadio);
    $.ajax({
      url: settings.apiUrl,
      method: 'POST',
      data: { 'term_id': id }
    }).done(function (response) {
      sendVoteDone(response);
      app.obj['preloader'].hidePreloader($currentRowRadio);
    });
  };

  var sendVoteDone = function sendVoteDone(response) {
    showResults(response['terms']);

    Cookies.set(settings.cookieName, 1, { expires: settings.expires });

    voted = true;
  };

  var showResults = function showResults(terms) {
    $el.addClass('is-results');
    $.each(terms, function (term_index, term) {
      var currentTerm = term;
      var $currentRow = $row.filter('[data-id="' + currentTerm['id'] + '"]');
      $currentRow.find(classes.rowPercentage).text(parseInt(currentTerm['percentage'] * 100) + '%');
    });
  };

  init();return api;
};

app.ext['tags'] = function ($el) {
  var api = {};

  var classes = {
    tag: '.js-tags-tag',
    chosen: '.js-tags-chosen',
    chosenLabel: '.js-tags-chosen-label',
    chosenRemove: '.js-tags-chosen-remove',
    chosenList: '.js-tags-chosen-list',
    searchInput: '.js-tags-search-input',
    searchResults: '.js-tags-search-results',
    searchResult: '.js-tags-search-result',
    searchNoResults: '.js-tags-search-no-results',
    input: '.js-tags-input'
  };

  var states = {
    isTemplate: 'is-template',
    hiddenTags: $('.tags__list--hidden').length > 0
  };

  var $tag = $(classes.tag, $el);
  var $chosen = $(classes.chosen, $el);
  var $chosenList = $(classes.chosenList, $el);
  var $input = $(classes.input, $el);
  var $searchInput = $(classes.searchInput, $el);
  var $searchResults = $(classes.searchResults, $el);
  var $searchResult = $(classes.searchResult, $el);
  var $searchNoResults = $(classes.searchNoResults, $el);

  var chosenArray = [];
  var tagLabels = [];
  var searchResultsOpen = false;

  var init = function init() {
    addListeners();
    getTagList();
  };

  var addListeners = function addListeners() {
    $tag.on('click', tagClickHandler);
    $searchInput.on('keyup', searchInputChangeHandler);
    $el.on('click', classes.chosen, chosenClickHandler);
    $searchResults.on('click', classes.searchResult, searchResultClickHandler);
  };

  var tagClickHandler = function tagClickHandler(e) {
    var $tag = $(this);
    var tagSlug = $tag.data('tagSlug');
    var tagLabel = $tag.text();
    addTag(tagSlug, tagLabel);
  };

  var chosenClickHandler = function chosenClickHandler(e) {
    var $tag = $(this);
    var tagSlug = $tag.data('tagSlug');
    removeTag($tag, tagSlug);
  };

  var searchResultClickHandler = function searchResultClickHandler(e) {
    var $result = $(this);
    var tagLabel = $result.data('tagLabel');
    selectTagByLabel(tagLabel);
    if (states.hiddenTags) {
      $searchInput.val(tagLabel);
      $('html, body').animate({
        scrollTop: $('.recipes__overview').offset().top - 200
      }, 500);
    } else {
      $searchInput.val('');
    }
    hideSearchResults();
  };

  var searchInputChangeHandler = function searchInputChangeHandler(e) {
    var searchString = $(this).val();
    if (searchString === '') {
      hideSearchResults();
    } else {
      showSearchResults();
      searchForResult(searchString);
    }
  };

  var addTag = function addTag(tagSlug, tagLabel) {
    if (states.hiddenTags) {
      // reset filter
      chosenArray.length = 0;
    }

    if (chosenArray.indexOf(tagSlug) > -1) return false;
    var $newTag = $chosen.clone().removeClass(states.isTemplate).data('tagSlug', tagSlug);
    $(classes.chosenLabel, $newTag).text(tagLabel);
    $chosenList.append($newTag);
    chosenArray.push(tagSlug);
    updateInput();
    disableOnTagList(tagSlug);
  };

  var removeTag = function removeTag($tag, tagSlug) {
    chosenArray = $.grep(chosenArray, function (value) {
      return value != tagSlug;
    });
    $tag.addClass(app.states.isHidden);
    setTimeout(function () {
      $tag.remove();
    }, 300);
    updateInput();
    enableOnTagList(tagSlug);
  };

  var updateInput = function updateInput() {
    $input.val(chosenArray.toString()).trigger('change');
  };

  var getTagList = function getTagList() {
    $tag.each(function () {
      var label = $(this).data('tagLabel');
      tagLabels.push(label);
      var $newSearchResult = $searchResult.clone().text(label).data('tagLabel', label).removeClass(states.isTemplate);
      $searchResults.append($newSearchResult);
    });
    $searchResult.remove();
    $searchResult = $(classes.searchResult, $searchResults);
  };

  var hideSearchResults = function hideSearchResults() {
    if (!searchResultsOpen) return false;
    searchResultsOpen = false;
    $searchResults.velocity('fadeOut', {
      duration: app.settings.duration
    });
  };

  var showSearchResults = function showSearchResults() {
    if (searchResultsOpen) return false;
    searchResultsOpen = true;
    $searchResults.velocity('fadeIn', {
      duration: app.settings.duration
    });
  };

  var searchForResult = function searchForResult(searchString) {
    searchString = searchString.toLowerCase();
    var elementFound = false;
    $searchResult.each(function () {
      var itemText = $(this).data('tagLabel').toLowerCase();
      if (itemText.startsWith(searchString)) {
        $(this).show();
        elementFound = true;
      } else {
        $(this).hide();
      }
    });
    if (!elementFound) {
      $searchNoResults.show();
    } else {
      $searchNoResults.hide();
    }
  };

  var disableOnTagList = function disableOnTagList(tagSlug) {
    var $chosenTag = $tag.filter('[data-tag-slug="' + tagSlug + '"]');
    $chosenTag.addClass(app.states.isDisabled);
  };

  var enableOnTagList = function enableOnTagList(tagSlug) {
    var $chosenTag = $tag.filter('[data-tag-slug="' + tagSlug + '"]');
    $chosenTag.removeClass(app.states.isDisabled);
  };

  var selectTagByLabel = function selectTagByLabel(tagLabel) {
    var $chosenTag = $tag.filter('[data-tag-label="' + tagLabel + '"]');
    $chosenTag.trigger('click');
  };

  init();return api;
};

app.ext['technologies'] = function ($el) {
  var api = {};

  var init = function init() {
    api.initSlider();
  };

  api.initSlider = function () {
    var mySwiper = new Swiper($el[0], {
      speed: 400,
      spaceBetween: 0,
      slidesPerView: 3,
      pagination: '.swiper-pagination',
      paginationClickable: true,
      breakpoints: {
        640: {
          slidesPerView: 1
        },
        1024: {
          slidesPerView: 2
        }
      }
    });
  };

  init();return api;
};

app.ext['time-increment'] = function ($el) {
  var api = {};

  var classes = {
    seconds: '.js-time-increment-seconds',
    value: '.js-time-increment-value'
  };

  var seconds = 0;
  var $seconds = $(classes.seconds, $el);
  var $value = $(classes.value, $el);
  var valueIncrements = [];
  var currentValues = [];
  var secondsText = $el.data('timeSeconds');
  var minutesText = $el.data('timeMinutes');

  var init = function init() {
    getValues();
    initIncrement();
  };

  var initIncrement = function initIncrement() {
    setInterval(function () {
      secondElapsed();
    }, 1000);
  };

  var getValues = function getValues() {
    $value.each(function (index) {
      var $currentValue = $(this);
      valueIncrements[index] = $currentValue.data('increment');
      currentValues[index] = 0;
    });
  };

  var secondElapsed = function secondElapsed() {
    seconds++;
    var calcMinutes = Math.floor(seconds / 60).toFixed(0);
    var calcSeconds = seconds % 60;
    var timeString = '';
    if (calcMinutes > 0) {
      timeString = calcMinutes + ' ' + minutesText + ' ';
    }
    timeString += calcSeconds + ' ' + secondsText;
    incrementSecondsIndicator(timeString);
    incrementValues();
  };

  var incrementSecondsIndicator = function incrementSecondsIndicator(timeString) {
    $seconds.text(timeString);
  };

  var incrementValues = function incrementValues() {
    $value.each(function (index) {
      var $currentValue = $(this);
      currentValues[index] += valueIncrements[index];
      $currentValue.text(currentValues[index].toFixed(1));
    });
  };

  init();return api;
};

app.ext['toggle-target'] = function ($el) {
  var api = {};

  var data = $el.data();

  var $target = $(data['target']);
  var autoclose = data['autoclose'];
  var autocloseAny = data['autocloseAny'];
  var targetScroll = data['targetScroll'];
  var targetJsSlide = data['targetJsSlide'];
  var targetOpen = false;

  var init = function init() {
    addListeners();
  };

  var addListeners = function addListeners() {
    $el.on('click', elClickHandler);
    if (autoclose) {
      $(document).on('triggereddocumentclick', documentClickHandler);
    }
  };

  var elClickHandler = function elClickHandler() {
    toggleTarget();
  };

  var documentClickHandler = function documentClickHandler(e, orignalE) {
    if (targetOpen) {
      if (!$(orignalE.target).closest($target).length || autocloseAny) {
        closeTarget();
      }
    }
  };

  var toggleTarget = function toggleTarget() {
    if (targetOpen) {
      closeTarget();
    } else {
      openTarget();
    }
  };

  var openTarget = function openTarget() {
    $target.addClass(app.states.isOpen);
    $el.addClass(app.states.isOpen);
    if (targetJsSlide) {
      $target.velocity('slideDown', {
        easing: app.settings.easeInOut,
        duration: app.settings.duration
      });
    }
    setTimeout(function () {
      targetOpen = true;
    }, 0);
    if (targetScroll !== undefined) {
      if (Gridle.isActive(targetScroll)) {
        app.obj['scroll-to'].scroll($target);
      }
    }
  };

  var closeTarget = function closeTarget() {

    if ($el.hasClass('js-search-trigger')) {
      $el.trigger('resetSearch');
    }

    $target.removeClass(app.states.isOpen);
    $el.removeClass(app.states.isOpen);
    if (targetJsSlide) {
      $target.velocity('slideUp', {
        easing: app.settings.easeInOut,
        duration: app.settings.duration
      });
    }
    setTimeout(function () {
      targetOpen = false;
    }, 0);
  };

  init();return api;
};

function rmlng(el, attr) {
  var st = el.attr(attr);
  if (st) {
    el.attr(attr, st.replace('/tr-tr/', '/'));
  }
}
$('*').each(function () {
  rmlng($(this), 'style');
});